/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc
 */
import * as References from './BuyerPreviewDataRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { restClient } from 'billing-portal-ui/js/clients/chirpClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: restClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc#getPaymentMethods
 */
export const GET_PAYMENT_METHODS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerPreviewDataRpc_getPaymentMethods';
export const GET_PAYMENT_METHODS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENT_METHODS_QUERY_FIELD_NAME,
  args: ['previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPaymentMethodsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc#getSubscriptions
 */
export const GET_SUBSCRIPTIONS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerPreviewDataRpc_getSubscriptions';
export const GET_SUBSCRIPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUBSCRIPTIONS_QUERY_FIELD_NAME,
  args: ['previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc#getInactiveSubscriptions
 */
export const GET_INACTIVE_SUBSCRIPTIONS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerPreviewDataRpc_getInactiveSubscriptions';
export const GET_INACTIVE_SUBSCRIPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INACTIVE_SUBSCRIPTIONS_QUERY_FIELD_NAME,
  args: ['previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getInactiveSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc#getInvoices
 */
export const GET_INVOICES_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerPreviewDataRpc_getInvoices';
export const GET_INVOICES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INVOICES_QUERY_FIELD_NAME,
  args: ['previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getInvoicesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewDataRpc#getCommercePayments
 */
export const GET_COMMERCE_PAYMENTS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerPreviewDataRpc_getCommercePayments';
export const GET_COMMERCE_PAYMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMMERCE_PAYMENTS_QUERY_FIELD_NAME,
  args: ['previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getCommercePaymentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});